import React from "react";

// POS numeric keypad (rvCalculator): 1-9, then C / 0 / DEL. Feeds the amount buffer (cents).
// C and DEL are marked as ghosts so the eye separates "clear" from the digits — hitting DEL when you
// meant 0 is the classic keypad error and colour is the cheapest defence against it.
const KEYS = ["1", "2", "3", "4", "5", "6", "7", "8", "9", "C", "0", "DEL"];
const LABEL = { C: "Clear", DEL: "Delete last digit" };

export default function Keypad({ onKey }) {
  return (
    <div className="qv-keys" role="group" aria-label="Amount keypad">
      {KEYS.map((k) => (
        <button
          key={k}
          type="button"
          className={k === "C" || k === "DEL" ? "qv-btn qv-key qv-btn--ghost" : "qv-btn qv-key qv-num"}
          onClick={() => onKey(k)}
          aria-label={LABEL[k] || k}
        >
          {k}
        </button>
      ))}
    </div>
  );
}
